import React, {useContext, useEffect, useState, useRef} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import PageSubHeader from '../../components/common/page_sub_header'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {API_URL, FORMAT} from '../../config/const'
import CKEditor from '@ckeditor/ckeditor5-react'
import {chkNoteTitle, fphoto, formatNumber} from '../../helper/common'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { registerLocale, setDefaultLocale } from  'react-datepicker'
import { ko } from 'date-fns/locale'
import EmojiInput from '../../components/control/custom_input/emoji_input'
import {rootStore} from '../../mobx/store'
import BettingBoxArea from './bettingbox_area'
import imageCompression from 'browser-image-compression';

const BJNew = observer((props) => {
  registerLocale('ko', ko)

  let priceList = [rootStore.getMe.price5_1, rootStore.getMe.price5_2, rootStore.getMe.price5_3, rootStore.getMe.price5_4];
  const data = props.location.state.data
  const context = useContext(Page_settings)
  const fileRef = useRef()
  let [title, setTitle] = useState('')
  let [content, setContent] = useState('')
  let [enabled, setEnabled] = useState(false)
  let [priceIdx, setPriceIdx] = useState(null)
  let [type, setType] = useState(null)
  let [img, setImg] = useState([])
  let [time, setTime] = useState('')
  const [isPickerOpen, setPickerOpen] = useState(false);
  const moment = require('moment')

  const [bettingData, setBettingData] = useState(null);

  const handleBettingDataUpdate = (data) => {
    setBettingData(data);
  };

  useEffect(() => {
    let _type = parseInt(props.match.params.type)
    if (!isNaN(_type)) setType(_type)

    if (data) {
      if (data.dat_photo !== '') {
        const dat_photo = data.dat_photo.split(',')
        let l = []
        for (let i = 0; i < dat_photo.length; i++) {
          l.push({path: dat_photo[i], url: fphoto(dat_photo[i], 'data'), file: null})
        }
        setImg(l)
      }
      let _type = parseInt(data.cate)
      if (!isNaN(_type)) setType(_type - 4);
      setTitle(data.dat_title)
      setPriceIdx(priceList.indexOf(data.dat_po))
      setTime(data.dat_start ?? '')
      setPickerOpen(data.dat_is_betting == 1);
    } else {
      // setTime(moment(moment.now()).format(FORMAT.DATE_TIME))
    }
  }, [props.match.params.type])

  useEffect(() => {
    if (data) {
      setEnabled(true)
      return
    }
    setEnabled(title !== '' && content !== '' && type != null && priceIdx != null && (!isPickerOpen || (isPickerOpen && bettingData != null)))
  }, [title, content, type, priceIdx, bettingData, isPickerOpen])

  const handleGameType = (event) => {
    let type = parseInt(event.target.value)
    if (isNaN(type)) type = 0
    setType(type)
  }

  const setStartTime = (v) => {

    const selectedTime = moment(v);
    const currentTime = moment();
  
    if (selectedTime.isValid() && selectedTime.isAfter(currentTime)) {
      setTime(selectedTime.format(FORMAT.DATE_TIME));
    } else {
      context.showAlert('현재 보다 이후 시간을 선택해주세요.')
    }
  }

  const onRemove = (index) => {
    setImg(prev => prev.filter((item, idx) => {return index !== idx}))
  }

  const addImages = (files, newImages) => {
    files.forEach((file) => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
  
        reader.onloadend = function () {
          newImages.push({
            path: '',
            url: reader.result,
            file: file,
          });
          setImg([...newImages]);
        };
        reader.readAsDataURL(file);
      }
    });
  }

  const compressImages = async (files) => {
    const options = {
      maxWidthOrHeight: 2048,
      useWebWorker: true,
    };

    const compressed = await Promise.all(
      files.map(file => imageCompression(file, options))
    );

    return compressed;
  };



  const handleDrop = async  (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    const compressedFiles = await compressImages(files);
    const newImages = [...img];
    addImages(compressedFiles, newImages);
  };
  
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const uploadFile = async (event) => {
    if (event.target.files.length < 1) {
      return;
    }
    const files = Array.from(event.target.files);
    const compressedFiles = await compressImages(files);
    const newImages = [...img];
    addImages(compressedFiles, newImages);

  };

  const onSaveData = (paths) => {
    let photo = paths
    let content1 = content
    let modify = 0
    if (data) {
      content1 = data.dat_note
      modify = 1
    }
    let price = priceList[priceIdx];
    let payload = {uid: data ? data.dat_id : 0, title: title, content: content1, cate: type + 4, start: time, photo: photo, modify: modify, price : price}
    if (modify == 0){
      if (isPickerOpen) {
        payload = { ...payload, round : bettingData.round, year : bettingData.year, data : JSON.stringify(bettingData), betting : 1 };
      } else {
        payload = { ...payload, betting : 0 };
      }
    }


    context.post('data/save_data', payload,
      () => {
        context.showAlert(data ? strings.bj_data_modified : strings.bj_data_registered, function () {
          props.history.replace('/my_data')
        }, strings.confirm)
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onSave = () => {
    if (!enabled) return
    if (time === '') {
      context.showAlert(strings.input_bj_time)
      return
    }
    let files = img.filter((item) => {return item.file != null})
    if (files.length > 0) {
      let formData = new FormData()
      formData.append('folder', 'data')
      for (let i = 0; i < files.length; i++) {
        formData.append('upload[' + i + ']', files[i].file)
      }
      context.post('upload/upload_files',
        formData,
        response => {
          onSaveData(response.file_urls.join(','))
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
    } else {
      onSaveData('')
    }
  }

  return (
    <React.Fragment>
      <div className='content-container' onDrop={handleDrop} onDragOver={handleDragOver}>
        <div className='im-container im-container-no-sidebar'>
          <PageSubHeader pageName={type === 0 ? strings.bj_pm_title : (type === 1 ? strings.bj_eve_title : '경기분석')} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={type === 0 ? strings.bj_pm_game : strings.bj_eve_game}/>
          <div className='al-header mt-30 sm-mt-15 fs-18 sm-fs-16 f-b'>{rootStore.getMe?.mb_nick} {strings.analyst_article}</div>
          <div className='al-content'>
            <label className='control-label'>{strings.article_type}<span className='text-danger'>*</span></label>
            <div className={`d-flex`} style={{gap : '16px'}}>
              <div className='bj-new-article-radio'>
                <input id="bj-new-pm" type="radio" value={0} checked={type === 0} disabled={data} onChange={handleGameType} />
                <label for="bj-new-pm">{strings.article_type_pm} {strings.article_type_data}</label>
              </div>
              <div className='bj-new-article-radio'>
                <input id="bj-new-eve" type="radio" value={1} checked={type === 1} disabled={data} onChange={handleGameType} />
                <label for="bj-new-eve">{strings.article_type_eve} {strings.article_type_data}</label>
              </div>
            </div>
            <label className='control-label mt-20'>{strings.option}</label>
            <select disabled={data && data.other_purchased == 1} className='form-control select-betting' value={priceIdx} onChange={(e) => { setPriceIdx(e.target.value)}}>
              <option value={null}>{strings.price_game_unselected}</option>
              <option value={0}>{strings.price_game_article_1}[{formatNumber(priceList[0]) + strings.point}]</option>
              <option value={1}>{strings.price_game_article_2}[{formatNumber(priceList[1]) + strings.point}]</option>
              <option value={2}>{strings.price_game_article_3}[{formatNumber(priceList[2]) + strings.point}]</option>
              <option value={3}>{strings.price_game_article_4}[{formatNumber(priceList[3]) + strings.point}]</option>
            </select>
            <label className='control-label mt-20'>{strings.title}<span className='text-danger'>*</span></label>
            <EmojiInput className={''} errorMsg={''} placeholder={strings.title_hint} inputType={'text'} maxLength={100} value={title} onChange={setTitle} />
            <label className='control-label mt-20'>{strings.game_start_time}<span className='text-danger'>*</span></label>
            <DatePicker
              placeholderText={strings.input_time}
              disabled={data}
              locale={ko}
              dateFormat="yyyy-MM-dd HH:mm"
              className={'d-block'}
              showTimeSelect
              timeIntervals={10}
              timeCaption="시간"
              selected={time === '' ? null : new Date(time)}
              onChange={(date) => {
                setStartTime(date);
              }}
              renderCustomHeader={({
                date,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div className='react-datepicker-flex'>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                  >
                   <img src={'/assets/image/nav-arrow-left.png'} alt='' width={16} height={16}/>
                  </button>
                  <h2 className="react-datepicker__current-month">{date.getFullYear()}년 {date.getMonth() + 1}월</h2>
                  <button
                    className='react-datepicker-init-btn'
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                  >
                   <img src={'/assets/image/nav-arrow-right.png'} alt='' width={16} height={16}/>
                   </button>
                </div>
              )}
            />
          
            <label className='control-label mt-20 sm-mt-18'>{strings.analyst_content}<span className='text-danger'>*</span></label>
            {(data) && <div className='bj-note-disable bj-note mb-40 fs-16 sm-fs-14' dangerouslySetInnerHTML={{ __html: data.dat_note }} />}
            {
              (!data) &&
              <CKEditor
                editor={ClassicEditor}
                data={content}
                config={{
                  isReadOnly: true,
                  ckfinder: {
                    uploadUrl: API_URL + '/api/upload/upload_file'
                  },
                  removePlugins: ['Image', 'ImageInsert', 'ImageUpload', 'ImageEditing', 'ImageCaption'],
                  placeholder: strings.data_new_input
                }}
                onChange={(event, editor) => {
                  setContent(editor.getData())
                }}
              />
            }

            <div className={'mv-20'}>
              {img.map((item, index) => {
                return (
                  <div className={'analyst_new_img'}><img src={'/assets/image/close.png'} onClick={() => onRemove(index)} alt='' hidden={item.file == null} className='img-delete'/><img key={index} src={item.url} alt={''}/></div>
                )})
              }
              <ConfirmButton enabled={true} className={'btn-attach1 fs-15 sm-fs-14 f-sb'} onClick={() => {fileRef?.current.click()}} text={strings.file_attach} />
              <input type='file' ref={fileRef} onChange={uploadFile} hidden={true} accept='image/*' multiple />
            </div>
          </div>
          <div class="al-header mt-30 sm-mt-15 fs-18 sm-fs-16 f-b">
            {strings.bjNewAddBettingbox}<img className='is_on cursor-point ml-20' src={isPickerOpen ? '/assets/image/is_on.png' : '/assets/image/is_off.png'} alt='' onClick={() => setPickerOpen(prev => !prev)} />
            <div className='fs-14 sm-fs-12 f-m mr-40' style={{marginLeft:'auto', whiteSpace : 'break-spaces'}} >{strings.betting_box_bj_guide}</div>
          </div>
          {isPickerOpen && <BettingBoxArea data={data} onBettingDataUpdate={handleBettingDataUpdate}></BettingBoxArea>}
          
          <ConfirmButton enabled={enabled} className={'btn btn-login mt-60 sm-mt-30 fs-15 sm-fs-14 f-m '} onClick={() => onSave()} text={data ? strings.do_modify : strings.make} />
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(BJNew)
